/** Tenant entitlement display; the server authorizes every command independently. */

import { useEffect, useState } from "react";
import { restGet } from "./restClient.js";

/** Entitlement keys, matching `shared_db::models`. */
export const ENTITLEMENTS = {
    ABAC: "abac",
    AI_VISIBILITY: "ai_visibility",
    ARTIFACT_ROLLOUT_CONTROL: "artifact_rollout_control",
    DISABLE_AUTO_UPDATE: "disable_auto_update",
    MANAGED_LLM_CHAT: "managed_llm_chat",
};

/** Entitled surfaces stay hidden until the tenant entitlement is confirmed. */
export function hasEntitlement(entitlements, key) {
    return entitlements?.includes(key) === true;
}

/** Return the tenant's entitlement keys, or null while unavailable. */
export function useTenantEntitlements() {
    const [entitlements, setEntitlements] = useState(null);

    useEffect(() => {
        let active = true;
        void (async () => {
            try {
                const response = await restGet("/v1/tenant/configuration");
                // An absent field is an older backend; an empty array is a
                // tenant that genuinely holds nothing. The gateway emits
                // unpopulated fields, so the two are distinguishable here.
                const keys = response?.entitlements;
                if (active && Array.isArray(keys)) setEntitlements(keys);
            } catch {
                // Keep display unknown on a failed read.
            }
        })();
        return () => {
            active = false;
        };
    }, []);

    return entitlements;
}
